import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { AddressDto } from 'interfaces/address';

interface AddressServices {
  searchAddress(queryParams?: any): Promise<AddressDto[]>;
}

const endpoints = {
  searchAddress: '/address/lookup',
};

export const addressesService: AddressServices = {
  searchAddress: async (queryParams?: any): Promise<AddressDto[]> => {
    const response: AxiosResponse<ApiResponseDto<AddressDto[]>> = await apiClient.get(endpoints.searchAddress, {
      params: { ...queryParams },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
